export default "https://d1e6s5z4lzmgxx.cloudfront.net/1e48d3d4-9cd4-48c4-b169-1af184d58c4c/images/metronome-icon.svg?9bb8edff54f1c5f654940ac123f2c181";